module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_on-03b3efaccdc946e5dd018038494c287b.svg";